export default "__VITE_ASSET__BqbuiAB1__"